import React from "react";
import PropTypes from "prop-types";

function Swatch({ space, colorScale }) {
  const values = new Array(space).fill(0).map((_, i) => i);
  if (!colorScale) return null;
  const scale = colorScale(space);

  return (
    <div className="tw-flex tw-items-center tw-px-1 tw-py-2">
      {values.map((x) => (
        <div
          key={x}
          style={{ backgroundColor: scale(x) }}
          className="tw-h-2 tw-w-2 tw-rounded-full tw-mr-0.5"
        />
      ))}
    </div>
  );
}

Swatch.propTypes = {
  space: PropTypes.number.isRequired,
  colorScale: PropTypes.func.isRequired,
};

Swatch.defaultProps = {};

export default Swatch;
